import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_10 = {
  key: 0,
  class: "row",
  id: "divHome"
}
const _hoisted_11 = { class: "col-md-2 col-6" }
const _hoisted_12 = { class: "col-md-2 col-6" }
const _hoisted_13 = { class: "col-md-2 col-6" }
const _hoisted_14 = { class: "col-md-2 col-6" }
const _hoisted_15 = { class: "col-md-2 col-6" }
const _hoisted_16 = {
  key: 1,
  class: "row",
  id: "divMeusDados"
}
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "col-md-12 mt-3" }
const _hoisted_19 = {
  key: 2,
  class: "row",
  id: "divMeusDependentes"
}
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "table table-striped" }
const _hoisted_22 = { class: "col-md-12 mt-3" }
const _hoisted_23 = {
  key: 3,
  class: "row",
  id: "divMeusContratos"
}
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-text" }
const _hoisted_29 = { class: "card-text" }
const _hoisted_30 = { class: "col-md-12 mt-3" }
const _hoisted_31 = {
  key: 4,
  class: "row",
  id: "divMeusBoletos"
}
const _hoisted_32 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_33 = { class: "table table-striped" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "table table-striped" }
const _hoisted_36 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_37 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_38 = { class: "col-md-12 mt-3" }
const _hoisted_39 = {
  key: 5,
  class: "row mt-2 mb-2",
  id: "divParceiros"
}
const _hoisted_40 = { class: "col-md-3 mb-2" }
const _hoisted_41 = { class: "col-md-3 mb-2" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "col-md-3 mb-2" }
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "card mb-3" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "card-body" }
const _hoisted_48 = { class: "card-title fw-bold" }
const _hoisted_49 = { class: "card-text endereco mb-0" }
const _hoisted_50 = {
  class: "card-text mb-0",
  title: "Telefone"
}
const _hoisted_51 = { key: 0 }

import { reactive, onMounted } from "vue";

//services
import * as clienteService from "@/services/clienteService";
import storeCliente from "@/utils/storeCliente";

import {f2dec, fdata, fdataHora} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

//vue
const controle = reactive({
  dadosCliente: null as clienteService.DadosCliente | null,
  parceiros: [] as clienteService.Parceiro[],
  filtrosParceiros: {
      pesquisa: "",
      cidadeId: null as number | null,
      paginaAtual: 1,
      tamanhoPagina: 12
  } as clienteService.ClienteParceirosFiltros,
  totalParceiros: 0,
  categorias: [] as clienteService.Categoria[],
  cidades: [] as clienteService.Cidade[],
  ver: "" as string,
  status: "" as string,
  erro: "" as string
});

onMounted(() => {
    setTimeout(() => {
        buscarDadosCliente();
        buscarCategorias();
        buscarParceiros();
        buscarCidades();
    }, 1000);
});

function buscarDadosCliente() {
    // Lógica para buscar os dados do cliente
    console.log("Buscando dados do cliente...");
    controle.status = "Buscando dados do cliente...";
    clienteService.obterDados()
        .then((r) => {
            console.log("Dados do cliente:", r);
            controle.status = "";
            controle.dadosCliente = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar dados do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
            setTimeout(() => {
                sair();
            }, 4000);
        });
}

function buscarCategorias() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando categorias...");
    controle.status = "Buscando categorias...";
    clienteService.obterCategorias()
        .then((r) => {
            controle.status = "";
            controle.categorias = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar categorias:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarParceiros() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando parceiros do cliente...");
    controle.status = "Buscando parceiros do cliente...";
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            console.log("Parceiros do cliente:", r);
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            console.error("Erro ao buscar parceiros do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    // Lógica para buscar as cidades
    console.log("Buscando cidades...");
    controle.status = "Buscando cidades...";
    clienteService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar cidades:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    storeCliente.token = "";
    window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "row mt-4 mb-3" }, [
      _createElementVNode("div", { class: "col-md-12" }, [
        _createElementVNode("h2", null, "Área do Cliente")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, " Bem-vindo, " + _toDisplayString(controle.dadosCliente ? controle.dadosCliente.cliente.nome : 'Cliente') + "! ", 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (controle.erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (controle.ver== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (controle.ver = 'meusDados'))
            }, [...(_cache[15] || (_cache[15] = [
              _createTextVNode(" Meu Cadastro ", -1),
              _createElementVNode("i", { class: "flaticon-user-3" }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (controle.ver = 'meusDependentes'))
            }, [...(_cache[16] || (_cache[16] = [
              _createTextVNode(" Meus Dependentes ", -1),
              _createElementVNode("i", { class: "flaticon-people" }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (controle.ver = 'meusBoletos'))
            }, [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" Meus Boletos ", -1),
              _createElementVNode("i", { class: "flaticon-document" }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (controle.ver = 'meusContratos'))
            }, " Meus Contratos ")
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sair()))
            }, [...(_cache[18] || (_cache[18] = [
              _createTextVNode(" Sair ", -1),
              _createElementVNode("i", { class: "flaticon-right-arrow-1" }, null, -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusDados')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-12" }, [
            _createElementVNode("h3", null, "Meus Dados")
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, " Nome: " + _toDisplayString(controle.dadosCliente?.cliente.nome), 1),
            _createElementVNode("div", null, " CPF: " + _toDisplayString(controle.dadosCliente?.cliente.cpf), 1),
            _createElementVNode("div", null, " RG: " + _toDisplayString(controle.dadosCliente?.cliente.rg), 1),
            _createElementVNode("div", null, " RG Expedidor: " + _toDisplayString(controle.dadosCliente?.cliente.rgExpedidor), 1),
            _createElementVNode("div", null, " Email: " + _toDisplayString(controle.dadosCliente?.cliente.email), 1),
            _createElementVNode("div", null, " Telefone: " + _toDisplayString(controle.dadosCliente?.cliente.telefone), 1),
            _createElementVNode("div", null, " Logradouro: " + _toDisplayString(controle.dadosCliente?.cliente.logradouro), 1),
            _createElementVNode("div", null, " Número: " + _toDisplayString(controle.dadosCliente?.cliente.numero), 1),
            _createElementVNode("div", null, " Bairro: " + _toDisplayString(controle.dadosCliente?.cliente.bairro), 1),
            _createElementVNode("div", null, " CEP: " + _toDisplayString(controle.dadosCliente?.cliente.complemento), 1),
            _createElementVNode("div", null, " Cidade: " + _toDisplayString(controle.dadosCliente?.cliente.cidade), 1),
            _createElementVNode("div", null, " Estado: " + _toDisplayString(controle.dadosCliente?.cliente.estado), 1),
            _createElementVNode("div", null, " CEP: " + _toDisplayString(controle.dadosCliente?.cliente.cep), 1),
            _createElementVNode("div", null, " Data Nascimento: " + _toDisplayString(controle.dadosCliente?.cliente.dataNascimento), 1),
            _createElementVNode("div", null, " Data Entrega Cartão: " + _toDisplayString(controle.dadosCliente?.cliente.dataEntregaCartao), 1),
            _createElementVNode("div", null, " Nome Conjuge: " + _toDisplayString(controle.dadosCliente?.cliente.nomeConjuge), 1),
            _createElementVNode("div", null, " CPF Conjuge: " + _toDisplayString(controle.dadosCliente?.cliente.cpfConjuge), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-sm",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusDependentes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-12" }, [
            _createElementVNode("h3", null, "Meus Dependentes")
          ], -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Nome"),
                  _createElementVNode("th", null, "Parentesco"),
                  _createElementVNode("th", null, "Data Nascimento")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.dependentes, (dependente) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: dependente.dependenteId
                  }, [
                    _createElementVNode("td", null, _toDisplayString(dependente.nome), 1),
                    _createElementVNode("td", null, _toDisplayString(dependente.parentesco), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(fdata)(dependente.dataNascimento)), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-sm",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusContratos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-12" }, [
            _createElementVNode("h3", null, "Meus Contratos")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.contratos, (contrato) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-6",
              key: contrato.contratoId
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h5", _hoisted_25, _toDisplayString(contrato.plano.nome), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h5", _hoisted_27, _toDisplayString(contrato.status.descricao), 1),
                  _createElementVNode("p", _hoisted_28, "Inicio: " + _toDisplayString(_unref(fdata)(contrato.dataInicio)) + ", Fim: " + _toDisplayString(_unref(fdata)(contrato.dataFim)), 1),
                  _createElementVNode("p", _hoisted_29, "Assinado em: " + _toDisplayString(_unref(fdataHora)(contrato.dataAssinatura)), 1),
                  (contrato.dataAssinatura == null)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        to: { name: 'PainelClienteAssinarContrato', params: { contratoId: contrato.contratoId } },
                        class: "btn btn-warning btn-sm me-1"
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("Assinar", -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_RouterLink, {
                    to: { name: 'PainelClienteVerContrato', params: { contratoId: contrato.contratoId } },
                    class: "btn btn-primary btn-sm"
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode("Ver", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-sm",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusBoletos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-md-12" }, [
            _createElementVNode("h3", null, "Meus Boletos")
          ], -1)),
          (controle.dadosCliente?.boletos?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("table", _hoisted_33, [
                  _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Nome"),
                      _createElementVNode("th", null, "Parentesco"),
                      _createElementVNode("th", null, "Data Nascimento")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.boletos, (boleto) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: boleto.boletoId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(boleto.codigoBarras), 1),
                        _createElementVNode("td", null, _toDisplayString(boleto.dataVencimento), 1),
                        _createElementVNode("td", null, _toDisplayString(boleto.valorDocumento), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(boleto.dataDocumento)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Parcela"),
                  _createElementVNode("th", null, "Vencimento"),
                  _createElementVNode("th", null, "Valor"),
                  _createElementVNode("th", null, "Contrato ID"),
                  _createElementVNode("th", null, "Referente"),
                  _createElementVNode("th", null, "Pagamento")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.mensalidades, (boleto) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: boleto.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(boleto.parcela), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(fdata)(boleto.dataVencimento)), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(f2dec)(boleto.valor)), 1),
                    _createElementVNode("td", null, _toDisplayString(boleto.contratoId), 1),
                    _createElementVNode("td", null, _toDisplayString(boleto.referente), 1),
                    _createElementVNode("td", null, [
                      (boleto.dataPagamento != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createTextVNode(_toDisplayString(_unref(fdata)(boleto.dataPagamento)) + " ", 1),
                            _cache[26] || (_cache[26] = _createElementVNode("i", { class: "flaticon-check" }, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[27] || (_cache[27] = [
                            _createTextVNode(" Em aberto ", -1),
                            _createElementVNode("i", { class: "flaticon-close" }, null, -1)
                          ]))]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-sm",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == '' )
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "col-md-12 mb-2" }, [
            _createElementVNode("h3", null, "Parceiros")
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _cache[30] || (_cache[30] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((controle.filtrosParceiros.pesquisa) = $event)),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (buscarParceiros())),
              placeholder: "Nome do parceiro"
            }, null, 544), [
              [_vModelText, controle.filtrosParceiros.pesquisa]
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _cache[32] || (_cache[32] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Categoria ")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((controle.filtrosParceiros.categoriaId) = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (buscarParceiros()))
            }, [
              _cache[31] || (_cache[31] = _createElementVNode("option", { value: null }, "- Todas Categorias - ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.categorias, (categoria) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: categoria.categoriaId,
                  value: categoria.categoriaId
                }, _toDisplayString(categoria.descricao), 9, _hoisted_42))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.categoriaId]
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[34] || (_cache[34] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-marker" }),
              _createTextVNode(" Cidade ")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((controle.filtrosParceiros.cidadeId) = $event)),
              onChange: _cache[14] || (_cache[14] = ($event: any) => (buscarParceiros()))
            }, [
              _cache[33] || (_cache[33] = _createElementVNode("option", { value: null }, "- Todas Cidades - ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.cidades, (cidade) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cidade.cidadeId,
                  value: cidade.cidadeId
                }, _toDisplayString(cidade.nome) + " - " + _toDisplayString(cidade.estado), 9, _hoisted_44))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.cidadeId]
            ])
          ]),
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-3" }, [
            _createElementVNode("a", { class: "btn btn-primary btn-sm mb-2 mt-4" }, " Ver todos ")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.parceiros, (parceiro) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-3",
              key: parceiro.parceiroId
            }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("img", {
                  src: _unref(imgSemImagem),
                  class: "card-img-top",
                  alt: "..."
                }, null, 8, _hoisted_46),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("h6", _hoisted_48, _toDisplayString(parceiro.nome), 1),
                  _createElementVNode("p", _hoisted_49, _toDisplayString(parceiro.logradouro != null ? parceiro.logradouro + ' ' + parceiro.numero + ' - ' : '') + " " + _toDisplayString(parceiro.bairro) + " - " + _toDisplayString(parceiro.cidade.nome) + " - " + _toDisplayString(parceiro.cidade.estado), 1),
                  _createElementVNode("p", _hoisted_50, [
                    _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-phone-call" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(parceiro.telefone), 1)
                  ]),
                  _createVNode(_component_RouterLink, {
                    to: { name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } },
                    class: "btn btn-primary btn-sm text-center"
                  }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createTextVNode("Ver", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]))
          }), 128)),
          (controle.parceiros.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [...(_cache[37] || (_cache[37] = [
                _createElementVNode("div", { class: "col-md-12" }, " Nenhum parceiro encontrado. ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})